import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree';

/**
 * The router is deliberately not registered into the module augmentation. Registering it
 * makes `to` a literal union of every path in the tree, which is a pleasant thing to have
 * and an unpleasant thing to hand eight agents building routes at the same time: every
 * half-finished tree turns every Link in the product into a type error.
 *
 * Integration can turn it on in one place once the tree is final.
 */
export function createOpsRouter() {
  return createRouter({
    routeTree,
    defaultPreload: 'intent',
    // Data comes from TanStack Query, so the router does not need its own cache.
    defaultPreloadStaleTime: 0,
    scrollRestoration: true,
  });
}
